<template>
  <div class="com" @click="closeModal($event)">
    <div class="txt">All fields are required</div>
    <div class="wrapper">
      <div class="form-wrap">
        <div class="input-wrap">
          <input
            type="text"
            @change="camelCaseVal('title', $event, title_count)"
            @focus="removeCaps('title', $event, 'focus')"
            v-on:keyup.delete="removeCaps('title', $event, 'delete')"
            v-model="title"
            v-validate="'required|max:100'"
            class="input"
            name="title"
            placeholder="Project Name"
            @input="onFocusOut"
          />
          <span class="validate-error zip" v-if="errors.has('title')">
            {{ errors.first("title") }}
          </span>
        </div>
        <div class="input-wrap small">
          <div class="input-title">Sampling Date</div>
          <div @click="showError" class="datepickerWrapDiv">
            <Datepicker
              :disabledDates="{ from: serverTime }"
              placeholder="Select Date"
              
              v-model="sampling_date"
              name="sampling_date"
              v-validate="'required'"
              :format="formatDate"
              :calendar-class="{ calendarWrap: true }"
              :class="{ datepickerWrap: true }"
              :input-class="{ datepickerInput: true, error: dateError }"
              @input="onFocusOut"
            ></Datepicker>
          </div>
        </div>
        <div class="inputs-wrap small">
          <div class="input-title">Who Collected the Samples?</div>
          <div class="input-wrap small">
            <input
              id="collected-first-name-reg-input"
              type="text"
              @change="changeVal('collected_first_name', $event, collected_first_name_count)"
              @focus="removeCaps('collected_first_name', $event, 'focus')"
              v-on:keyup.delete="removeCaps('collected_first_name', $event, 'delete')"
              v-model="collected_first_name"
              v-validate="'required|max:50'"
              class="input"
              name="collected_first_name"
              placeholder="First Name"
              @input="onFocusOut"
            />
            <span
              class="validate-error zip"
              v-if="errors.has('collected_first_name')"
              >{{ errors.first("collected_first_name") }}</span
            >
          </div>
          <div class="input-wrap small">
            <input
              id="collected-last-name-reg-input"
              type="text"
              @change="changeVal('collected_last_name', $event, collected_last_name_count)"
              @focus="removeCaps('collected_last_name', $event, 'focus')"
              v-on:keyup.delete="removeCaps('collected_last_name', $event, 'delete')"
              v-model="collected_last_name"
              v-validate="'required|max:50'"
              class="input"
              name="collected_last_name"
              placeholder="Last Name"
              @input="onFocusOut"
            />
            <span
              class="validate-error zip"
              v-if="errors.has('collected_last_name')"
              >{{ errors.first("collected_last_name") }}</span
            >
          </div>
        </div>
        <div class="inputs-wrap small">
          <div class="input-title">Where Were Samples Collected?</div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              v-validate="'regex:[0-9]|required|numeric|length:5'"
              placeholder="Zip Code"
              name="zip"
              data-vv-as="Zip Code"
              maxlength="5"
              @input="getZip"
              v-model="zip"
            />
            <span
              class="validate-error zip"
              v-if="zip && zip.length > 0 && errors.has('zip')"
            >
              The zip code is invalid
            </span>
          </div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              placeholder="Address"
              v-validate="'required'"
              name="address"
              maxlength="50"
              @change="camelCaseVal('address', $event, address_count)"
              @focus="removeCaps('address', $event, 'focus')"
              v-on:keyup.delete="removeCaps('address', $event, 'delete')"
              v-model="address"
              @input="onFocusOut"
            />
          </div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              name="city"
              placeholder="City"
              maxlength="25"
              v-validate="'required'"
              @change="changeVal('city', $event, city_count)"
              @focus="removeCaps('city', $event, 'focus')"
              v-on:keyup.delete="removeCaps('city', $event, 'delete')"
              v-model="city"
              @input="onFocusOut"
            />
          </div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              name="state"
              v-validate="'required'"
              placeholder="State"
              maxlength="25"
              @change="changeVal('state', $event, state_count)"
              @focus="removeCaps('state', $event, 'focus')"
              v-on:keyup.delete="removeCaps('state', $event, 'delete')"
              v-model="state"
              @input="onFocusOut"
            />
          </div>
        </div>
        <div class="inputs-wrap small">
          <div class="inputs-wrap dropdown-wrap">
            <div class="input-title">Outdoor Samples</div>
            <div class="dropdown-container" v-on:mouseleave="showOutdoorSelect = false">
              <input
                name="Outdoor Sample"
                v-model="outdoorSample"
                @click="showOutdoorSelect = !showOutdoorSelect"
                placeholder="Select"
                readonly
                class="input dropdown-input"
              />
              <img
                src="../../../images/shared/drop.png"
                alt="#"
                class="drop-down-icone"
              />
              <ul class="dropDown" v-show="showOutdoorSelect">
                <li class="dropDown-item" @click="setOutdoorItem('Front Entrance')"><span>Front Entrance</span></li>
                <li class="dropDown-item" @click="setOutdoorItem('Back Entrance')"><span>Back Entrance</span></li>
                <li class="dropDown-item" @click="setOutdoorItem('Side Entrance')"><span>Side Entrance</span></li>
                <li class="dropDown-item" @click="setOutdoorItem('Balcony')"><span>Balcony</span></li>
                <li class="dropDown-item dropDown-item--input">
                  <input
                    type="text"
                    v-model="outdoorSample"
                    @change="changeVal('outdoorSample', $event, 0)"
                    class="dropDownInput"
                    @keyup.enter="showOutdoorSelect = false"
                    placeholder="Enter Other Description"
                    maxlength="33"
                  />
                </li>
              </ul>
            </div>
            <span class="validate-error zip" v-if="outdoorSample && outdoorSample.length > 33">
              Outdoor Sample may not exceed 33 characters.
            </span>
          </div>
          <div class="descriptionInput"><span class="first-sent">The outdoor sample is required to produce a report.</span> The formula for calculating results depends largely upon a comparison between the indoor samples and the outdoor sample.</div>
        </div>
        <div class="inputs-wrap small">
          <div class="inputs-wrap small dropdown-wrap" v-for="(item, index) in samples" :key="index">
            <div class="input-title">Indoor Sample #{{ index + 1 }}</div>
            <div class="dropdown-container" v-on:mouseleave="closeIndoorSelect()">
              <input
                :name="'Indoor Sample #' + (index + 1)"
                v-model="sampleTypes[index]"
                @click="openIndoorDropdown(index)"
                placeholder="Select"
                readonly
                class="input dropdown-input"
              />
              <img
                src="../../../images/shared/drop.png"
                alt="#"
                class="drop-down-icone"
              />
              <ul class="dropDown" v-show="activeDropdown === index">
                <li v-for="option in indoorOptions" :key="option"
                  class="dropDown-item"
                  :class="{ disabled: isIndoorOptionTaken(option, index) }"
                  @click="!isIndoorOptionTaken(option, index) && setIndoorItem(option, index)"
                ><span>{{ option }}</span></li>
                <li class="dropDown-item dropDown-item--input">
                  <input
                    type="text"
                    :value="sampleTypes[index]"
                    @input="setIndoorItem($event.target.value, index)"
                    class="dropDownInput"
                    @keyup.enter="closeIndoorSelect()"
                    placeholder="Enter Other Description"
                    maxlength="33"
                  />
                </li>
              </ul>
            </div>
            <span class="validate-error zip" v-if="sampleTypes[index] && sampleTypes[index].length > 33">
              Indoor Sample {{ index + 1 }} may not exceed 33 characters.
            </span>
          </div>
        </div>
        <div class="inputs-wrap small">
          <div class="validate-errors" v-if="errorMessage !== ''">
            <span v-html="errorMessage"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <button
        class="btn"
        @click.prevent="$validator.validateAll()"
        @click="switchStep"
        :disabled="!isComputed"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Step3",
  data() {
    return {
      title: "",
      sampling_date: "",
      dateError: false,
      collected_first_name: "",
      collected_last_name: "",
      zip: null,
      state: null,
      address: null,
      city: null,
      outdoorSample: "",
      showOutdoorSelect: false,
      activeDropdown: -1,
      samples: [],
      sampleTypes: [],
      errorMessage: "",
      title_count: 0,
      collected_first_name_count: 0,
      address_count: 0,
      city_count: 0,
      state_count: 0,
      collected_last_name_count: 0,
      indoorOptions: [
        'Attic', 'Basement', 'Bathroom', 'Crawlspace', 'Dining Room',
        'Garage', 'Living Room', 'Master Bedroom', 'Utility Room',
        'Water Heater Closet', 'Family Room'
      ]
    };
  },
  methods: {
    ...mapActions(["sendTempSubV2", "saveKitV2Details", "fetchServerTime"]),
    setOutdoorItem(txt) {
      this.outdoorSample = txt;
      this.showOutdoorSelect = false;
      this.checkDuplicates();
    },
    openIndoorDropdown(index) {
      this.activeDropdown = this.activeDropdown === index ? -1 : index;
    },
    closeIndoorSelect() {
      this.activeDropdown = -1;
    },
    setIndoorItem(txt, index) {
      this.$set(this.sampleTypes, index, txt);
      this.activeDropdown = -1;
      this.checkDuplicates();
    },
    isIndoorOptionTaken(option, currentIndex) {
      return this.sampleTypes.some((val, i) => i !== currentIndex && val && val.toUpperCase() === option.toUpperCase());
    },
    checkDuplicates() {
      this.errorMessage = "";
      const all = [...this.sampleTypes];
      if (this.outdoorSample) all.push(this.outdoorSample);
      const seen = {};
      all.forEach((val, i) => {
        if (val && val.trim()) {
          const key = val.toUpperCase();
          if (seen[key]) {
            this.errorMessage = "Each sample must have a unique name.";
          }
          seen[key] = true;
        }
      });
    },
    onFocusOut() {
      let sampling_date = "", collected_first_name = "", collected_last_name = "", city = "", state = "";
      let zip = "", address = "";

      if (!this.errors.has('sampling_date')) {
        sampling_date = this.sampling_date;
      }
      if (!this.errors.has('collected_first_name')) {
        collected_first_name = this.collected_first_name;
      }
      if (!this.errors.has('collected_last_name')) {
        collected_last_name = this.collected_last_name;
      }
      if (!this.errors.has('city')) {
        city = this.city;
      }
      if (!this.errors.has('zip')) {
        zip = this.zip;
      }
      if (!this.errors.has('address')) {
        address = this.address;
      }
      if (!this.errors.has('state')) {
        state = this.state;
      }

      const user = {
        sampling_date,
        collected_first_name,
        collected_last_name,
        city,
        zip,
        state,
        address,
        kit_id: this.$store.getters.userInfo.kit_id
      };

      this.sendTempSubV2(user);
    },
    getZip() {
      let self = this;
      this.zip = this.zip ? this.zip.substr(0, 5).replace(/\D/g, "") : "";
      if (!self.state && !self.city && this.zip.length === 5) {
        this.onFocusOut();
        fetch(`https://ziptasticapi.com/${this.zip}`)
          .then(res => {
            return res.json();
          })
          .then(res => {
            self.state = res.state;
            self.city = this.capitalizeVal(res.city);
          });
      }
    },
    formatDate(date) {
      return moment(date).format("MMMM D, YYYY");
    },
    showError(e) {
      this.sampling_date === ""
        ? (this.dateError = true)
        : (this.dateError = false);
    },
    removeCaps(model, e, type) {
      if (type == 'focus') {
        let val = 0;
        if (e.target.value.length > 0) {
          val = 1;
        }
        if (model == "title") {
          this.title_count = val;
        } else if (model == "collected_first_name") {
          this.collected_first_name_count = val;
        } else if (model == "city") {
          this.city_count = val;
        } else if (model == "state") {
          this.state_count = val;
        } else if (model == "collected_last_name") {
          this.collected_last_name_count = val;
        } else if (model == "address") {
          this.address_count = val;
        }
      } else if (e.target.value.length == 0) {
        if (model == "title" && this.title_count == 0) {
          this.title_count = this.title_count + 1;
        } else if (model == "collected_first_name" && this.collected_first_name_count == 0) {
          this.collected_first_name_count = this.collected_first_name_count + 1;
        } else if (model == "city" && this.city_count == 0) {
          this.city_count = this.city_count + 1;
        } else if (model == "state" && this.state_count == 0) {
          this.state_count = this.state_count + 1;
        } else if (model == "collected_last_name" && this.collected_last_name_count == 0) {
          this.collected_last_name_count = this.collected_last_name_count + 1;
        } else if (model == "address" && this.address_count == 0) {
          this.address_count = this.address_count + 1;
        }
      }
    },
    changeVal(model, e, count) {
      if (count == 0 && e.target.value.length > 0) {
        e.target.value = this.capitalizeVal(e.target.value);
        e.target.style.textTransform = 'none';
      }
      if (model === "state") {
        this[model] =
          e.target.value.length <= 2
            ? e.target.value.toUpperCase()
            : e.target.value;
      } else {
        this[model] = e.target.value;
      }
    },
    camelCaseVal(model, e, count) {
      if (count == 0 && e.target.value.length > 0) {
        e.target.value = this.camelCapitalizeVal(e.target.value);
        e.target.style.textTransform = 'none';
      }
      if (model === "state") {
        this[model] =
          e.target.value.length <= 2
            ? e.target.value.toUpperCase()
            : e.target.value;
      } else {
        this[model] = e.target.value;
      }
    },
    switchStep() {
      if (!this.isComputed || this.errors.any() || this.dateError) {
        return;
      }
      const indoorSamples = this.samples.map((item, index) => ({
        type: this.sampleTypes[index],
        id: item.id || null,
        kit_v2_id: item.kit_v2_id || null
      }));
      const user = {
        kit_id: this.$store.getters.userInfo.kit_id,
        title: this.title,
        sampling_date: this.sampling_date,
        collected_first_name: this.collected_first_name,
        collected_last_name: this.collected_last_name,
        address: this.address,
        zip: this.zip,
        city: this.city,
        state: this.state,
        outdoor_sample: this.outdoorSample,
        indoor_samples: indoorSamples
      };
      this.saveKitV2Details(user).then(() => {
        this.$emit("nextStep", 1);
      });
    },
    prev() {
      this.$emit("prevStep", {
        step: 1,
        notificationData: {
          emailInput: false,
          phoneInput: false,
          errorCode: true,
          emailInputVer: false,
          phoneInputVer: false
        }
      });
    },
    closeModal(e) {
      if (
        e.target.offsetParent &&
        e.target.offsetParent.className === "form large"
      ) {
        this.showOutdoorSelect = false;
        this.activeDropdown = -1;
      }
    },
    capitalizeVal(input) {
      return input
        ? input.replace(/^\w{1,}|\w{4,}/g, function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
        : input;
    },
    camelCapitalizeVal(input) {
      return input
        ? input
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.substring(1))
            .join(" ")
        : input;
    }
  },
  computed: {
    isComputed() {
      const samplesValid = this.samples.length === 0 || this.sampleTypes.every(t => t && t.trim());
      return (
        this.title &&
        this.sampling_date &&
        this.collected_first_name &&
        this.collected_last_name &&
        this.zip &&
        this.city &&
        this.state &&
        this.address &&
        this.outdoorSample &&
        samplesValid &&
        this.errorMessage === ""
      );
    },
    serverTime() {
      const time = this.$store.getters.getServerTime;
      return time ? new Date(time) : new Date();
    },
    ...mapGetters(["userInfo", "gettestuser"])
  },
  watch: {
    userInfo(state) {
      if (this.$store.getters.userInfo.cron_status == 1) {
        if (this.$store.getters.userInfo.collected_first_name) {
          this.collected_first_name = this.$store.getters.userInfo.collected_first_name;
          var collected_first_name_field = document.getElementById('collected-first-name-reg-input');
          if (collected_first_name_field) collected_first_name_field.classList.add("disabled");
        }
        if (this.$store.getters.userInfo.collected_last_name) {
          this.collected_last_name = this.$store.getters.userInfo.collected_last_name;
          var collected_last_name_field = document.getElementById('collected-last-name-reg-input');
          if (collected_last_name_field) collected_last_name_field.classList.add("disabled");
        }
      }
      // Load V2 samples
      const info = this.$store.getters.userInfo;
      if (info && info.samples) {
        this.samples = info.samples;
        this.sampleTypes = info.samples.map(s => s.type || "");
      }
      if (info && info.outdoor_sample) {
        this.outdoorSample = info.outdoor_sample;
      }
    },
    gettestuser(kitData) {
      // Prepopulate when tempuser data arrives asynchronously (e.g. resuming activated kit)
      if (kitData && typeof kitData === 'object' && Object.keys(kitData).length > 0) {
        if (kitData.sampling_date && !this.sampling_date) this.sampling_date = kitData.sampling_date;
        if (kitData.collected_first_name && !this.collected_first_name) this.collected_first_name = kitData.collected_first_name;
        if (kitData.collected_last_name && !this.collected_last_name) this.collected_last_name = kitData.collected_last_name;
        if (kitData.address && !this.address) this.address = kitData.address;
        if (kitData.zip && !this.zip) this.zip = kitData.zip;
        if (kitData.city && !this.city) this.city = kitData.city;
        if (kitData.state && !this.state) this.state = kitData.state;
        if (kitData.title && !this.title) this.title = kitData.title;
        if (kitData.outdoor_sample && !this.outdoorSample) this.outdoorSample = kitData.outdoor_sample;
      }
    }
  },
  mounted() {
    const info = this.$store.getters.userInfo;

    // Prepopulate from tempuser data (saved during previous incomplete activation)
    const kitData = this.$store.getters.gettestuser;
    if (kitData && typeof kitData === 'object' && Object.keys(kitData).length > 0) {
      this.sampling_date = kitData.sampling_date || "";
      this.collected_first_name = kitData.collected_first_name || "";
      this.collected_last_name = kitData.collected_last_name || "";
      this.address = kitData.address || null;
      this.zip = kitData.zip || null;
      this.city = kitData.city || null;
      this.state = kitData.state || null;
      this.title = kitData.title || "";
      if (kitData.outdoor_sample) {
        this.outdoorSample = kitData.outdoor_sample;
      }
    }

    // Initialize samples from store
    if (info && info.samples) {
      this.samples = info.samples;
      this.sampleTypes = info.samples.map(s => s.type || "");
    }
    if (info && info.outdoor_sample) {
      this.outdoorSample = info.outdoor_sample;
    }
    if (info && info.title) {
      this.title = info.title;
    }
    // Prefill from V2 kit data when resuming activation after login
    if (info && info.collected_first_name) {
      this.collected_first_name = info.collected_first_name;
    }
    if (info && info.collected_last_name) {
      this.collected_last_name = info.collected_last_name;
    }
    if (info && info.sampling_date) {
      this.sampling_date = info.sampling_date;
    }
    if (info && info.address && typeof info.address === 'object') {
      this.address = info.address.address || null;
      this.zip = info.address.zip || null;
      this.city = info.address.city || null;
      this.state = info.address.state || null;
    }
  },
  components: {
    Datepicker
  },
  created() {
    this.fetchServerTime();
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.wrapper {
  width: 100%;
}
.btn-wrap {
  width: 100%;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.com {
  margin: 20px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.txt {
  color: $blue;
  margin: -15px 0 20px;
  font-size: 14px;
  text-align: center;
  font-family: TTNormsLight, sans-serif;
  width: 100%;
}
.input {
  border-radius: 10px;
  padding: 15px 20px;
  color: $gray;
  width: 100%;
  font-size: 16px;
  border: 1px solid #cccccc;
  text-align: center;
  outline: none;
  margin: 0;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
}
.input-wrap {
  margin: 0 0 15px;
}
.input.invalid {
  border: 1px solid $red;
}
.input-wrap.small {
  width: 100%;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 20px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  max-width: 300px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 36px auto 0 auto;
}
.input-title {
  color: $gray;
  padding: 6px 0 11px 0;
  display: block;
  text-align: center;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  outline: none;
}
.inputs-wrap {
  margin: 0 0 5px;
  position: relative;
}
.inputs-wrap.small {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input.invalid:focus {
  border: 1px solid rgb(77, 144, 254);
}
@media (max-width: 568px) {
  .btn {
    height: 40px;
    font-size: 16px;
  }
  .back-btn {
    font-size: 16px;
  }
}
.disabled {
  pointer-events: none;
  background-color: #e7e9eb;
}
.dropdown-wrap {
  margin-bottom: 10px;
}
.dropdown-container {
  position: relative;
}
.dropdown-input {
  cursor: pointer;
  padding-right: 40px;
}
.drop-down-icone {
  position: absolute;
  right: 15px;
  top: 18px;
  width: 14px;
  pointer-events: none;
  transition: transform 0.2s ease;
}
.dropDown {
  list-style: none;
  padding: 4px 0;
  margin: 4px 0 0 0;
  border: 1px solid #cccccc;
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 10;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 250px;
  overflow-y: auto;
}
.dropDown-item {
  padding: 10px 20px;
  cursor: pointer;
  font-family: TTNormsMedium, sans-serif;
  font-size: 14px;
  color: $gray;
  text-align: center;
  transition: background-color 0.15s ease;
  &:hover {
    background-color: #e8f0fe;
  }
  &.disabled {
    opacity: 0.4;
    pointer-events: none;
    cursor: default;
    text-decoration: line-through;
    &:hover {
      background-color: transparent;
    }
  }
  &.dropDown-item--input {
    padding: 6px 12px;
    border-top: 1px solid #e8e8e8;
    &:hover {
      background-color: transparent;
    }
  }
}
.dropDownInput {
  width: 100%;
  border: none;
  outline: none;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
  font-size: 14px;
  color: $gray;
  padding: 6px 8px;
  border-radius: 6px;
  &:focus {
    background-color: #f5f7fa;
  }
  &::placeholder {
    color: $lightGray;
    font-size: 13px;
  }
}
.descriptionInput {
  padding: 10px;
  color: $gray;
  width: 100%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  .first-sent {
    font-family: TTNormsMedium, sans-serif;
  }
}
.validate-errors {
  color: $red;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
  width: 100%;
}
</style>
